// Small helper to normalize route paths and URLs for canonical/link consistency.
// Ensures leading slash, collapses duplicate slashes, and guarantees a trailing
// slash for path-like values (but preserves file-like paths that include a dot).
function isFullUrl(s) {
  return /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(s);
}

export function normalizeRoute(input) {
  if (!input && input !== '') return '/';
  try {
    const raw = String(input).trim();
    if (isFullUrl(raw)) {
      const u = new URL(raw);
      u.pathname = u.pathname.replace(/\/+$|\/+/g, '/');
      // ensure trailing slash for directory-like paths
      const seg = u.pathname.split('/').filter(Boolean).slice(-1)[0] || '';
      if (!u.pathname.endsWith('/') && !seg.includes('.')) u.pathname = u.pathname + '/';
      return u.toString();
    }

    // Path-only value
    let p = raw;
    if (!p.startsWith('/')) p = '/' + p;
    // collapse duplicate slashes
    p = p.replace(/\/+/g, '/');
    // if last segment looks like a filename (contains a dot), don't force trailing slash
    const lastSeg = p.split('/').filter(Boolean).slice(-1)[0] || '';
    if (lastSeg && lastSeg.includes('.')) return p;
    if (!p.endsWith('/')) p = p + '/';
    return p;
  } catch (e) {
    return input;
  }
}

export default normalizeRoute;
